import React, {Fragment} from 'react';

export default {
  title: "Advanced usage",
  content: <Fragment></Fragment>
};